module.exports = __webpack_public_path__ + "static/media/desktop_live_ic_weibo@2x.8be9ab99.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/live/assets/desktop_live_ic_weibo@2x.png
// module id = 409
// module chunks = 0